// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Card,
//   Col,
//   CardTitle,
//   CardBody,
//   Button,
//   Table,
//   CardFooter,
// } from 'reactstrap';
// import { useNavigate } from 'react-router-dom';
// import { apiService } from '../../constants/ApiService';
// import { useSelector } from 'react-redux';
// import { formatDate } from '../../constants/DateFormatter';

// const StudentAcSearch = ({ systemData }) => {
//   const navigate = useNavigate();
//   const [admissionList, setAdmissionList] = useState([]);
//   const [classMasterData, setClassMasterData] = useState([]);
//   const sessionData = useSelector((state) => state.sessionState)

//   const [search, setSearch] = useState("");
//   const [curr_sec, setcurr_sec] = useState("");
//   const [curr_class, setcurr_class] = useState("");
//   const onHandleAddAdmission = () => {
//     navigate('/addAdmission');
//   };


//   const onHandleSearchKeyItem = (e) => {
//     const value = e.target.value;
//     GetAdmission(1, 10, value);
//   };

//   const onHandleEditParty = (id) => {
//     let findArrayData = admissionList.find((e) => e.id === id);
//     navigate('/StudentAc', { state:  findArrayData });
//   };



//   const GetAdmission = async (page = 1, limit = 10, search = '') => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json',
//           accept: 'application/json',
//         },
//       };

//       let apiUrl = `api/Admission/GetAdmission?search=${search}&page=${page}&limit=${limit}`;

//       // If search is not empty, get all records and then slice the last 10
//       if (search !== '') {
//         apiUrl = `api/Admission/GetAdmission?search=${search}`;
//       }

//       const response = await apiService.get(apiUrl, config);

//       if (response.response && response.response.data.errors) {
//         alert(response.response?.data?.errors);
//       }

//       if (response.status === true) {
//         let admissionData = response.data;

//         // If search is not empty, slice the last 10 records
//         if (search !== '') {
//           admissionData = admissionData.slice(-10);
//         }

//         setAdmissionList(admissionData);
//         //setTotalPage(response.totalPages); // Update the totalPage state
//         console.log(admissionData);
//       } else {
//         alert(response.message);
//       }
//     } catch (error) {
//       console.log(error);
//       alert('Something went wrong!!');
//     }
//   };



//   const fetchData = async () => {
//     try {
//       const queryParams = new URLSearchParams();

//       //queryParams.append("session", sessionData.session_year)
//       if (search) queryParams.append("search", search);
//       if (curr_class) queryParams.append("curr_class", curr_class);
//       if (curr_sec) queryParams.append("curr_sec", curr_sec);


//       const response = await apiService.get(`api/Admission/GetAdmission?${queryParams.toString()}`);
//       if (response.status === true) {
//         setAdmissionList(response.data)
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     GetCurrectClassInfo();
//   }, [search, curr_class, curr_sec]);


//   // useEffect(() => {
//   //   GetAdmission();
//   // }, [!admissionList]);

//   const tableRef = useRef();

//   const GetCurrectClassInfo = async () => {
//     try {
//       let config = {
//         headers: {
//           'Content-Type': 'application/json',
//           accept: 'application/json',
//         },
//       };

//       const response = await apiService.get(
//         `api/Admission/GetClass_MasterGroupData`,
//         config
//       );

//       setClassMasterData(response.item2);
//     } catch (error) {
//       console.log(error);
//       alert('SomeThing went wrong');
//     }
//   };



//   return (
//     <>

//       <Col lg='12'>
//         <Card className='card-box height-100-p pd-20 mb-20'>
//           <CardTitle
//             tag='h6'
//             className='p-3 mb-0 d-flex align-items-center justify-content-between'
//           >
//             <div className='d-flex align-items-center'>
//               <i className='bi bi-card-text mr-2'></i>
//               Search Student A/c 
//             </div>



//           </CardTitle>

//           <div id="dateFilterForm" className="row g-3 align-items-end p-3">
//             <div className="col-12 col-md-7">
//               <div className="input-group">
//                 <span className="input-group-text"><i className="bi bi-search"></i></span>
//                 <input type="text" onChange={(e) => { setSearch(e.target.value) }} className="form-control" placeholder="Search entries..." aria-label="Search" />
//               </div>
//             </div>
//             <div class="col-12 col-md-5">
//               <div class="input-group">
//                 <span class="input-group-text">Class</span>
//                 <select
//                   name="curr_class"
//                   value={curr_class}
//                   onChange={(e) => setcurr_class(e.target.value)}
//                   className="custom-select" aria-label="Status curr_class">
//                   <option value="" selected>-Select-</option>
//                   {classMasterData.map((option) => (
//                     <option key={option} value={option}>
//                       {option}
//                     </option>
//                   ))}
//                 </select>
//                 <span class="input-group-text">Sec</span>
//                 <select
//                   name="curr_sec"
//                   value={curr_sec}
//                   onChange={(e) => setcurr_sec(e.target.value)}
//                   className="custom-select" aria-label="Status filter">
//                   <option value="" selected>-Select-</option>
//                   <option value="A">A</option>
//                   <option value="B">B</option>
//                   <option value="C">C</option>
//                   <option value="D">D</option>
//                 </select>
//               </div>
//             </div>
//           </div>

//           <CardBody>
//             <div ref={tableRef} className='table-responsive' style={{ overflowX: 'auto', maxWidth: '150vh', whiteSpace: 'nowrap' }}>
//               <Table hover striped responsive>
//                 <thead>
//                   <tr>
//                     <th>S.no.</th>
//                     <th className='no-print'></th>
//                     <th>Adm. No.</th>
//                     <th>D.O.A</th>
//                     <th>Student Name</th>
//                     <th>Gender</th>
//                     <th>D.O.B</th>
//                     <th>Father Name</th>
//                     <th>Mother Name</th>
//                     <th>Address</th>
//                     <th>Class & Sec</th>
//                     <th>Religion</th>
//                     <th>Category</th>

//                     {/* <th>Delete</th> */}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {admissionList.length ? (
//                     admissionList.map((item, index) => (
//                       <tr key={index}>
//                         <th scope='row'>{index + 1}</th>
//                         <td className='no-print'>
//                           <i
//                             style={{ cursor: "pointer" }}
//                             onClick={() => onHandleEditParty(item.id)}
//                             className='bi bi-search text-primary'></i>
//                         </td>
//                         <td>{item.admit_no}</td>
//                         <td style={{ whiteSpace: "nowrap", minWidth: "70px" }}>{formatDate(item.adm_date)}</td>

//                         <td>{item.stud_name}</td>
//                         <td>{item.sex_mf}</td>
//                         <td style={{ whiteSpace: "nowrap", minWidth: "70px" }}>{formatDate(item.d_o_b)}</td>

//                         <td>{item.f_name}</td>
//                         <td>{item.m_name}</td>
//                         <td>{item.sadd1},{item.sadd2}</td>
//                         <td>{item.curr_class} {item.curr_sec}</td>
//                         <td>{item.religion_name}</td>
//                         <td>{item.category_class}</td>

//                         {/* <td>
//                       <Button
//                         color='danger'
//                         size='bg'
//                         onClick={() => onHandleDeleteAdmission(item.id)}
//                       >
//                         Delete
//                       </Button>
//                     </td> */}
//                       </tr>
//                     ))
//                   ) : (
//                     <>
//                       <tr>
//                         <td className='text-center' colSpan={13}>No data available</td>
//                       </tr>
//                     </>
//                   )}
//                 </tbody>
//               </Table>
//             </div>
//           </CardBody>
//           <CardFooter className='text-right'>
//             (Showing latest 10 entries by default)
//           </CardFooter>
//         </Card>
//       </Col>
//     </>
//   );
// };

// export default StudentAcSearch;
//
import React, { useState, useEffect, useRef } from 'react';
import {
  Card,
  Col,
  CardTitle,
  CardBody,
  Label,
  Button,
  Table,
  CardFooter,
} from 'reactstrap';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { formatDate } from '../../constants/DateFormatter';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';

const StudentAcSearch = ({ systemData }) => {
  const navigate = useNavigate();
  const [admissionList, setAdmissionList] = useState([]);
  const [classOptions, setClassOptions] = useState([]);
  const [errorMessage, setErrorMessage] = useState({});
  const { user } = useSelector((state) => state.authState);
  const sessionState = useSelector((state) => state.sessionState);

  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);

  const [search, setSearch] = useState("");
  const [curr_sec, setcurr_sec] = useState("");
  const [curr_class, setcurr_class] = useState("");

  const onHandleAddAdmission = () => {
    navigate('/addAdmission');
  };

  const [selectionData, setSelectionData] = useState({
    vendor_id: '',
    branch_id: '',
  });

  const onHandleSearchKeyItem = (e) => {
    const value = e.target.value;
    GetAdmission(1, 10, value);
  };

  const onHandleEditParty = (item) => {
    navigate('/StudentAc', { state: item });
  };

  const GetAdmission = async (page = 1, limit = 10, search = '') => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      let apiUrl = `api/Enrollment/GetAllEnrollment?search=${search}&page=${page}&limit=${limit}`;

      if (search !== '') {
        apiUrl = `api/Enrollment/GetAllEnrollment?search=${search}`;
      }

      const response = await apiService.get(apiUrl, config);

      if (response.response && response.response.data.errors) {
        alert(response.response?.data?.errors);
      }

      if (response.status === true) {
        let admissionData = response.data;
        console.log(admissionData);

        if (search !== '') {
          admissionData = admissionData.slice(-10);
        }

        setAdmissionList(admissionData);
        console.log(admissionData);
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong!!');
    }
  };

  const fetchData = async () => {
    try {

      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const queryParams = new URLSearchParams();

      if (vendorId) queryParams.append("vendorId", vendorId);
      if (branchId) queryParams.append("branchId", branchId);

      //queryParams.append("session", sessionData.session_year)

      queryParams.append('vendorId', String(vendorId));
      queryParams.append('branchId', String(branchId));
      if (search) queryParams.append("search", search);
      if (curr_class) queryParams.append("classId", curr_class);
      if (curr_sec) queryParams.append("curr_sec", curr_sec);


      const response = await apiService.get(`api/Enrollment/GetAllEnrollment?${queryParams.toString()}`);
      if (response.status === true) {
        setAdmissionList(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

// ---------- Reload on filters ----------
  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: selectionData.vendor_id,
      branchId: selectionData.branch_id,
    });
    if (!canLoad) return;

    fetchData();
    fetchClasses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    search,
    curr_class,
    curr_sec,
    isAdmin,
    isSuperAdmin,
    selectionData.vendor_id,
    selectionData.branch_id,
  ]);


  const tableRef = useRef();

  const fetchClasses = async (searchText = '') => {
    try {
      const vendorId = selectionData.vendor_id || '';
      const branchId = selectionData.branch_id || '';

      const res = await apiService.get(
        `api/ClassMaster/GetClassMaster?vendorId=${vendorId}&branchId=${branchId}&searchItem=${encodeURIComponent(
          searchText || '',
        )}`,
      );

      if (res?.status === true) {
        const raw = res?.data || [];
        const opts = (raw || [])
          .map((x) => ({
            value: String(x.id ?? x.ID ?? x.class_id ?? x.classId ?? ''),
            label: String(
              x.class_display_name ??
              x.class_Name ??
              x.className ??
              x.name ??
              'No Name',
            ),
          }))
          .filter((o) => o.value && o.value !== '0');

        setClassOptions(opts);
      } else {
        setClassOptions([]);
      }
    } catch (err) {
      console.error(err);
      setClassOptions([]);
    }
  };


  return (
    <>

      <VendorBranchSelector
        user={user}
        selectionData={selectionData}
        setSelectionData={setSelectionData}
        errorMessage={errorMessage}
        accessButton={true}
      />
      <Card className='card-box height-100-p pd-20 mb-20'>
        {/* Header */}
        <div className='d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3'>
          <div>
            <h4 className='fw-bold text-primary mb-1'>
              <i className='bi bi-person-lines-fill mr-2'></i> Search Student A/c
            </h4>
            <small className='text-muted'>
              Showing{' '}
              <span className='fw-semibold'>{admissionList.length}</span>{' '}
              records
            </small>
          </div>

          <div className='position-relative'>
            <input
              type='search'
              value={search}
              onChange={(e) => { setSearch(e.target.value) }}
              className='form-control'
              placeholder='Search students...'
            />
          </div>
        </div>

        {/* Filters */}
        <div className='row g-3 mb-4'>
          <Col md='9'>
            <Label className='mb-1'>Select a Course</Label>
            <Select
              options={classOptions}
              value={
                classOptions.find(
                  (o) => String(o.value) === String(curr_class),
                ) || null
              }
              onChange={(opt) => setcurr_class(opt ? String(opt.value) : '')}
              onInputChange={(val, meta) => {
                if (meta.action === 'input-change') fetchClasses(val);
              }}
              isClearable
              isSearchable
              placeholder='Type a Course Name...'
            />
          </Col>

          {/* <Col md='6'>
                      <Label className='mb-1'>Select a Session</Label>
                      <Select
                        options={sessionOptions}
                        value={
                          sessionOptions.find(
                            (o) => String(o.value) === String(selectedSessionYear),
                          ) || null
                        }
                        onChange={(opt) =>
                          setSelectedSessionYear(opt ? String(opt.value) : '')
                        }
                        onInputChange={(val, meta) => {
                          if (meta.action === 'input-change') fetchSessions(val);
                        }}
                        isClearable
                        isSearchable
                        placeholder='Type and Choose a Session...'
                      />
                    </Col> */}
        </div>


        {/*     <div id="dateFilterForm" className="row g-3 align-items-end p-3">
            <div className="col-12 col-md-7">
              <div className="input-group">
                <span className="input-group-text"><i className="bi bi-search"></i></span>
                <input
                  type="text"
                  onChange={(e) => { setSearch(e.target.value) }}
                  className="form-control"
                  placeholder="Search entries..."
                  aria-label="Search"
                />
              </div>
            </div>
        <div class="col-12 col-md-5">
                 
        
              <div class="input-group">
                <span class="input-group-text">Class</span>
                <select
                  name="curr_class"
                  value={curr_class}
                  onChange={(e) => setcurr_class(e.target.value)}
                  className="custom-select"
                  aria-label="Status curr_class"
                >
                  <option value="">-Select-</option>
                  {classMasterData.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select> 
             

                {/* <span class="input-group-text">Sec</span>
                <select
                  name="curr_sec"
                  value={curr_sec}
                  onChange={(e) => setcurr_sec(e.target.value)}
                  className="custom-select"
                  aria-label="Status filter"
                >
                  <option value="">-Select-</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                </select>
              </div> 
            </div> 
          </div>*/}

        <CardBody>
          <div ref={tableRef} className='table-responsive' style={{ overflowX: 'auto', maxWidth: '150vh', whiteSpace: 'nowrap' }}>
            <Table hover striped responsive>
              <thead>
                <tr>
                  <th>S.no.</th>
                  <th className='no-print'></th>
                  <th>Adm. No.</th>
                  {/* <th>D.O.A</th> */}
                  <th>Student Name</th>
                  <th>Father Name</th>
                  {/* <th>Gender</th>
                  <th>D.O.B</th>
                  <th>Mother Name</th>
                  <th>Address</th> */}
                  <th>Class & Sec</th>
                  {/* <th>Religion</th>
                  <th>Category</th> */}

                  {/* <th>Delete</th> */}
                </tr>
              </thead>
              <tbody>
                {admissionList.length ? (
                  admissionList.map((item, index) => (
                    <tr key={index}>
                      <th scope='row'>{index + 1}</th>
                      <td className='no-print'>
                        <i
                          style={{ cursor: "pointer" }}
                          onClick={() => onHandleEditParty(item)}
                          className='bi bi-search text-primary'></i>
                      </td>
                      <td>{item.admit_no}</td>
                      {/* <td style={{ whiteSpace: "nowrap", minWidth: "70px" }}>{formatDate(item.adm_date)}</td> */}

                      <td>{item.student_name}</td>
                      <td>{item?.admission?.f_name}</td>
                      {/* <td>{item.sex_mf}</td> 
                      <td style={{ whiteSpace: "nowrap", minWidth: "70px" }}>{formatDate(item.d_o_b)}</td>

                      <td>{item.m_name}</td>
                      <td>{item.sadd1},{item.sadd2}</td>*/}
                      <td>{item.course_name}</td>
                      {/* <td>{item.religion_name}</td>
                      <td>{item.category_class}</td> */}

                      {/* <td>
                      <Button
                        color='danger'
                        size='bg'
                        onClick={() => onHandleDeleteAdmission(item.id)}
                      >
                        Delete
                      </Button>
                    </td> */}
                    </tr>
                  ))
                ) : (
                  <>
                    <tr>
                      <td className='text-center' colSpan={13}>No data available</td>
                    </tr>
                  </>
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
        <CardFooter className='text-right'>
          (Showing latest 10 entries by default)
        </CardFooter>
      </Card>
    </>
  );
};

export default StudentAcSearch;